import QrScanStyles from 'shared/style/qrScanStyles'
import retryIcon from 'shared/assets/retry.svg'

const QrScannerControls = ({hasScannedData, onRescan, isLoading}) => {
	return (
		<QrScanStyles.ControlButtons>
			{hasScannedData ? (
				<QrScanStyles.ClearButton onClick={onRescan} disabled={isLoading}>
					<img src={retryIcon} alt='retry' />
					다시 스캔
				</QrScanStyles.ClearButton>
			) : null}
		</QrScanStyles.ControlButtons>
	)
}

export default QrScannerControls
